import type { ComponentPropsWithoutRef } from "react";

import { cn } from "../lib/utils";

export const CONVERSATION_STATUS_ICON_SOURCES = {
  archived: "/icons/conversations/archived.svg",
  canceled: "/icons/conversations/canceled.svg",
  completed: "/icons/conversations/completed.svg",
} as const;

export const CONVERSATION_PLUS_ICON_SOURCE = "/icons/conversations/plus.svg";
export const SIDEBAR_TOGGLE_ICON_SOURCE = "/icons/conversations/sidebar.svg";

export type ConversationStatusIconName = keyof typeof CONVERSATION_STATUS_ICON_SOURCES;

type DecorativeImageProps = Omit<
  ComponentPropsWithoutRef<"img">,
  "alt" | "aria-hidden" | "draggable" | "src"
>;

function DecorativeIconImage({
  className,
  src,
  ...props
}: DecorativeImageProps & { readonly src: string }) {
  return (
    <img
      alt=""
      aria-hidden="true"
      className={cn("shrink-0 select-none", className)}
      draggable={false}
      src={src}
      {...props}
    />
  );
}

export function ConversationStatusIcon({
  className,
  status,
  ...props
}: DecorativeImageProps & { readonly status: ConversationStatusIconName }) {
  return (
    <DecorativeIconImage
      className={cn("size-3.5", className)}
      src={CONVERSATION_STATUS_ICON_SOURCES[status]}
      {...props}
    />
  );
}

export function ConversationPlusIcon({ className, ...props }: DecorativeImageProps) {
  return (
    <DecorativeIconImage
      className={cn("size-4", className)}
      src={CONVERSATION_PLUS_ICON_SOURCE}
      {...props}
    />
  );
}

export function SidebarToggleIcon({ className, ...props }: DecorativeImageProps) {
  return (
    <DecorativeIconImage
      className={cn("size-4", className)}
      src={SIDEBAR_TOGGLE_ICON_SOURCE}
      {...props}
    />
  );
}
